const backendUrl = process.env.REACT_APP_BACKEND_URL;

let isGlobalImageFallbackInstalled = false;

export const getFallbackLogoUrl = (): string => {
  return backendUrl ? `${backendUrl}/django-static/logo/logo.jpg` : '/django-static/logo/logo.jpg';
};

export const getDynamicPictureUrl = (imageName?: string): string => {
  if (!imageName) {
    return getFallbackLogoUrl();
  }

  return `${backendUrl}/django-dynamic/pictures/${imageName}`;
};

export const applyImageFallback = (event: React.SyntheticEvent<HTMLImageElement, Event>): void => {
  const imageElement = event.currentTarget;

  imageElement.onerror = null;
  imageElement.src = getFallbackLogoUrl();

  if (!imageElement.alt) {
    imageElement.alt = 'Website logo';
  }
};

export const installGlobalImageFallback = (): void => {
  if (isGlobalImageFallbackInstalled) {
    return;
  }

  isGlobalImageFallbackInstalled = true;

  document.addEventListener(
    'error',
    (event) => {
      const target = event.target;

      if (!(target instanceof HTMLImageElement)) {
        return;
      }

      if (target.dataset.fallbackApplied === 'true' || target.src === getFallbackLogoUrl()) {
        return;
      }

      target.dataset.fallbackApplied = 'true';
      target.src = getFallbackLogoUrl();

      if (!target.alt) {
        target.alt = 'Website logo';
      }
    },
    true,
  );
};
